import { onMounted, onBeforeUnmount } from "vue";

export function useCloseKeyboard() {
	const handleClick = (e) => {
		const active = document.activeElement;

		const isInput = active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.isContentEditable);

		if (isInput && !e.target.closest("input, textarea, [contenteditable]")) {
			active.blur();
		}
	};

	onMounted(() => {
		document.addEventListener("click", handleClick);
	});

	onBeforeUnmount(() => {
		document.removeEventListener("click", handleClick);
	});
}
